<template>
  <div class="upload-wrap clearfix">
    <Upload v-if="edit" :multiple="false" :accept="accept" type="drag" action="/" ref="uploads" class="uploadBoxs" :before-upload="handleUpload">
      <div v-if="imgList" class="demo-upload-list">
        <img :src="imgList" style="width: 120px" />
        <div class="demo-upload-list-cover">
          <Icon type="ios-eye-outline" @click.native.stop="handleView(imgList)"></Icon>
          <Icon type="ios-trash-outline" @click.native.stop="handleRemove()"></Icon>
        </div>
      </div>
      <div v-show="!imgList" style="padding: 20px 0">
        <Icon type="ios-add" size="52" style="color: #3399ff"></Icon>
        <span v-if="txt">{{ txt }}</span>
      </div>
    </Upload>
    <div v-else>
      <div v-if="imgList" class="demo-upload-list">
        <img :src="imgList" style="width: 120px" />
        <div class="demo-upload-list-cover">
          <Icon type="ios-eye-outline" @click.native.stop="handleView(imgList)"></Icon>
        </div>
      </div>
    </div>
    <p class="tip">{{ tip }}</p>
    <Modal v-model="visible" :footer-hide="true" :closable="false" :width="modalWidth ? modalWidth : '600px'">
      <img :src="curImg" v-if="visible" style="width: 100%" />
    </Modal>
  </div>
</template>

<script>
export default {
  components: {},
  name: "upLoad",
  props: {
    arr: {
      type: String
    },
    fileType: {
      default:'img',
    },
    txt: {
      type: String
    },
    tip: {
      type: String
    },
    modalWidth: {
      type: String
    },
    edit: {
      type: Boolean,
      default: true
    }

  },
  data() {
    return {
      visible: false,
      curImg: "",
      imgList: '',
      isShowMask: [],
    };
  },
  watch: {
    arr: {
      handler(newVal) {
        if (newVal) {
          this.imgList = newVal
        } else {
          this.imgList = "";
        }
      },
      immediate: true, //刷新加载 立马触发一次handler
      // deep: true  // 可以深度检测到 person 对象的属性值的变化
    },
  },
  computed:{
    accept(){
      if(this.fileType == 'img') {
        return ".jpg,.png,.jpge";
      } else {
        return "";
      }
    }
  },

  methods: {
    handleView(item) {
      console.log('----', item)
      this.curImg = item;
      this.visible = true;
    },
    // mouseover(index) {
    //   this.$set(this.isShowMask, index, true);
    //   console.log(this.isShowMask);
    // },
    // mouseleave(index) {
    //   this.$set(this.isShowMask, index, false);
    // },
    handleRemove() {
      this.imgList = '';
      this.$emit("upload", '');
    },
    handleUpload(file) {
      console.log(file)
      if (this.fileType == 'img' && !/\.(png|jpg|jpeg)$/.test(file.name.toLowerCase())) {
        this.$Message.error("上传格式不正确，请上传图片格式文件");
        return false;
      }
      if (this.fileType == 'video' && !/\.(mp4)$/.test(file.name.toLowerCase())) {
        this.$Message.error("上传格式不正确，请上传mp4格式文件");
        return false;
      }
      this.$emit("upload", file);
      return false;
    },
  },
  created() { },
  mounted() { },
};
</script>
<style lang="scss" scoped>
.tip {
  color: #727c8e;
  font-size: 12px;
  position: absolute;
  left: 0;
  bottom: -24px;
  white-space: nowrap;
}

/deep/.ivu-upload-select {
  display: flex;
}

/deep/ .ivu-modal-content {
  background: transparent;
  box-shadow: none;
  outline: none;
}

/deep/ .ivu-modal-body {
  background: transparent;
}

.upload-wrap {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  height: 120px;
  width: 120px;

  .uploadBoxs {
    width: 100%;
    height: 100%;

   /deep/ .ivu-upload-drag {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .demo-upload-list {
    display: inline-block;
    text-align: center;
    width: 120px;
    height: 120px;
    line-height: 120px;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
  }

  .demo-upload-list img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    align-items: center;
    justify-content: center;
  }

  .demo-upload-list:hover .demo-upload-list-cover {
    display: flex;
  }

  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .imgList {
    float: left;

    li {
      position: relative;
      float: left;
      width: 120px;
      height: 120px;
      margin: 10px;

      .close {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        text-align: center;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          margin-right: 10px;
        }

        &:hover {
          cursor: pointer;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      img {
        &:hover {
          cursor: pointer;
        }

        width: 100%;
        height: 100%;
      }
    }
  }

}</style>
